import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import {MatIconModule} from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-group-management',
  imports: [
    MatSelectModule, MatIconModule, MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    CommonModule,
    FormsModule, ReactiveFormsModule
  ],
  templateUrl: './group-management.component.html',
  styleUrl: './group-management.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupManagementComponent {

}
